/* eslint-disable no-restricted-syntax */
// enum de tipo de condicion
export const CONDITION_TYPES = {
  GROUP: 'group',
  CONDITION: 'condition'
};
export const GROUP_MATCHS_TYPES = {
  ALL: 'all',
  ANY: 'any'
};

export const CONDITION_MATCHS_TYPES = {
  EQUAL: 'equal',
  NOT_EQUAL: 'not_equal',
  STARTS_WITH: 'starts_with',
  ENDS_WITH: 'ends_with',
  REGEX_MATCH: 'regex_match',
  LESS_THAN: 'less_than',
  LESS_THAN_INCLUSIVE: 'less_than_inclusive',
  GREATER_THAN: 'greater_than',
  GREATER_THAN_INCLUSIVE: 'greater_than_inclusive',
  IN: 'in',
  NOT_IN: 'not_in',
  CONTAINS: 'contains',
  NOT_CONTAINS: 'not_contains',
};

export const CONDITION_MATCH_TYPES_NAMES = {
  // Texto
  [CONDITION_MATCHS_TYPES.EQUAL]: 'Es Igual',
  [CONDITION_MATCHS_TYPES.NOT_EQUAL]: 'Es Diferente',
  [CONDITION_MATCHS_TYPES.STARTS_WITH]: 'Comienza con',
  [CONDITION_MATCHS_TYPES.ENDS_WITH]: 'Termina con',
  [CONDITION_MATCHS_TYPES.REGEX_MATCH]: 'Coincide con expresión',
  [CONDITION_MATCHS_TYPES.CONTAINS]: 'Contiene',
  [CONDITION_MATCHS_TYPES.NOT_CONTAINS]: 'No contiene',
  // Multiple
  [CONDITION_MATCHS_TYPES.IN]: 'En lista',
  [CONDITION_MATCHS_TYPES.NOT_IN]: 'No esta en la lista',
  // Numerico
  [CONDITION_MATCHS_TYPES.LESS_THAN]: 'Menor que',
  [CONDITION_MATCHS_TYPES.LESS_THAN_INCLUSIVE]: 'Menor o igual que',
  [CONDITION_MATCHS_TYPES.GREATER_THAN]: 'Mayor que',
  [CONDITION_MATCHS_TYPES.GREATER_THAN_INCLUSIVE]: 'Mayor o igual que'
};

export const CONDITION_IS_MULTIPLE = [
  CONDITION_MATCHS_TYPES.IN,
  CONDITION_MATCHS_TYPES.NOT_IN,
];
export const CONDITION_IS_NUMERIC = [
  CONDITION_MATCHS_TYPES.LESS_THAN,
  CONDITION_MATCHS_TYPES.LESS_THAN_INCLUSIVE,
  CONDITION_MATCHS_TYPES.GREATER_THAN,
  CONDITION_MATCHS_TYPES.GREATER_THAN_INCLUSIVE
];

export function buildEmptyCondition() {
  return {
    type: CONDITION_TYPES.CONDITION,
    path: '',
    operator: 'equal',
    value: ''
  };
}
export function buildEmptyGroup() {
  return {
    type: CONDITION_TYPES.GROUP,
    value: 'all',
    conditions: []
  };
}

const buildConditionFromStored = (condition) => {
  let item = {
    type: undefined,
  };
  // si condition es una lista o un objeto
  if (Array.isArray(condition)) {
    // es una lista de condiciones
    item.type = CONDITION_TYPES.GROUP;
    item.conditions = condition.map((cond) => buildConditionFromStored(cond));
  } else if (
    condition[GROUP_MATCHS_TYPES.ALL]
    || condition[GROUP_MATCHS_TYPES.ANY]
  ) {
    // es el inicio de un grupo
    item.type = CONDITION_TYPES.GROUP;
    item.conditions = [];
    for (const key in condition) {
      if (key === GROUP_MATCHS_TYPES.ALL || key === GROUP_MATCHS_TYPES.ANY) {
        item.value = key;
        item.conditions = condition[key].map((cond) => buildConditionFromStored(cond));
      }
    }
  } else {
    // es una condicion
    item.type = CONDITION_TYPES.CONDITION;
    item = {
      ...item,
      ...condition
    };
  }
  return item;
};

export function buildFromStored(storedData = {}) {
  const data = {
    name: storedData.name,
    conditions: []
  };
  data.conditions.push(buildConditionFromStored(storedData.conditions));
  return data;
}

export const jsonPathTypes = [
  {
    label: 'Archivo es público',
    description: 'Archivo es público (S/N)',
    value: '$.detail.item.esPublico'
  },
  {
    label: 'Mime type del archivo',
    description: 'EJ: image/jpeg',
    value: '$.detail.item.mime'
  },
  {
    label: 'Nombre del archivo',
    description: 'Nombre del archivo',
    value: '$.detail.item.nombre'
  },
  {
    label: 'Peso del archivo',
    description: 'Peso en bytes',
    value: '$.detail.item.pesoArchivo'
  },
  {
    label: 'Código archivo',
    description: 'Codigo de tipo archivo pre definido',
    value: '$.detail.item.codType'
  }
];
